'use es6';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { NavItemEnum } from '../constants/Mon569SidenavConfig';
export const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  const regExp = new RegExp(Object.values(NavItemEnum).join('|'));
  const match = pathname.match(regExp);
  const pageName = match ? match[0] : '';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageName]);
  return null;
};